import React from 'react';
import { withTranslation } from 'react-i18next';
import moment from 'moment';

const calculateChildCount = (date, childLessons, lessonTypes) => {
	return Object.entries(childLessons).filter(entry => {
		const lesson = entry[1];
		return lessonTypes.includes(lesson.lessonType) && sameDate(lesson.lessonDate, date);
	}).length;
};

const sameDate = (first, second) => {
	const firstParsed = moment(first).startOf('day');
	const secondParsed = moment(second).startOf('day');
	return firstParsed.isSame(secondParsed);
};

const EnrolmentCount = ({ t, enableTrials, enableMakeUps, date, childLessons, weeklyProgramItem, separator = <br />, className, style }) => {

	return <div className={className} style={style}>{`${calculateChildCount(date, childLessons, [1])}/${(weeklyProgramItem && weeklyProgramItem.maxChildrenRest) || 0} ${t('LessonAttendance_NormalCount')}`}
		{enableTrials && separator}
		{enableTrials && `${calculateChildCount(date, childLessons, [2])}/${(weeklyProgramItem && weeklyProgramItem.maxTrialChildrenRest) || 0} ${t('LessonAttendance_TrialCount')}`}
		{enableMakeUps && separator}
		{enableMakeUps && `${calculateChildCount(date, childLessons, [3])}/${(weeklyProgramItem && weeklyProgramItem.maxMakeUpChildrenRest) || 0} ${t('LessonAttendance_MakeUpCount')}`}
	</div>;
};

export default withTranslation()(EnrolmentCount);